import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  EmailListItem,
  EmailDetail,
  ComposeMail,
  DomainConfig,
} from '../models/mail.model';

@Injectable({ providedIn: 'root' })
export class MailService {
  private baseUrl = '/api';

  constructor(private http: HttpClient) {}

  getDomainConfig(): Observable<DomainConfig> {
    return this.http.get<DomainConfig>(`${this.baseUrl}/config/domains`);
  }

  fetchMails(recipient: string): Observable<{ message: string; new_count: number }> {
    return this.http.post<{ message: string; new_count: number }>(
      `${this.baseUrl}/mails/fetch`,
      { recipient }
    );
  }

  listMails(recipient: string): Observable<EmailListItem[]> {
    return this.http.get<EmailListItem[]>(`${this.baseUrl}/mails`, {
      params: { recipient },
    });
  }

  getMail(id: number): Observable<EmailDetail> {
    return this.http.get<EmailDetail>(`${this.baseUrl}/mails/${id}`);
  }

  sendMail(mail: ComposeMail, files: File[] = []): Observable<{ message: string; message_id: string }> {
    const formData = new FormData();
    formData.append('sender', mail.sender);
    formData.append('recipient', mail.recipient);
    formData.append('subject', mail.subject);
    formData.append('body_html', mail.body_html);
    if (mail.reply_to_message_id) {
      formData.append('reply_to_message_id', mail.reply_to_message_id);
    }
    for (const file of files) {
      formData.append('files', file);
    }
    return this.http.post<{ message: string; message_id: string }>(
      `${this.baseUrl}/mails/send`,
      formData
    );
  }

  getAttachmentUrl(attachmentId: number): string {
    return `${this.baseUrl}/attachments/${attachmentId}`;
  }

  getAttachmentPreviewUrl(attachmentId: number): string {
    return `${this.baseUrl}/attachments/${attachmentId}/preview`;
  }
}
